export interface EmployeesArray {
  id: number;
  employeeCode: string;
  name: string;
  password: string;
  isDairen: boolean;
  isAdmin: boolean;
}

export type EmployeesGetResponse = {
  items: EmployeesArray[];
  page: number;
  totalPages: number;
};

export const EmptyEmployeesGetResponse: EmployeesGetResponse = {
  items: [],
  page: 0,
  totalPages: 0,
};
